// extracted by mini-css-extract-plugin
export default {"menu":"profile-menu_menu__zKkTW","link":"profile-menu_link__-N2T6","active":"profile-menu_active__Zp66S","info":"profile-menu_info__PPUth"};